import React from 'react';
import { SlidePage } from '../index';
import { BodyContainer } from '../styles';
import DonutChart from '../SemiDonutChart';
import medalIcon from '../imgs/medal_icon.png';
import targetIcon from '../imgs/target_icon.png';

const MotivationScalesDescriptionCont = ({ user, background, number }) => {
  // sub-scales
  const { ML_SUB_SUM, MS_SUB_SUM } = user;

  // const MA_SUB = (parseInt(MA_SUB_SUM) / 30) * 100;
  const MS_SUB = (parseInt(MS_SUB_SUM) / 30) * 100;
  const ML_SUB = (parseInt(ML_SUB_SUM) / 30) * 100;
  return (
    <SlidePage number={number} background={background}>
      <BodyContainer>
        <div className='content'>
          <h3>4.1.2. Motivación al aprendizaje instrumental</h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={targetIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'MS_SUB',
                    label: MS_SUB.toFixed(0) + '%',
                    value: MS_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                Se relaciona con un{' '}
                <strong>interés más superficial por aprender</strong>. Las
                personas estudian para evitar una mala nota solamente, por lo
                que no invierten muchos esfuerzos. El estudio se centra en el
                mínimo que se necesita para cumplir con las exigencias
                académicas (por ejemplo, para poder sacarse un 4.0). Este tipo
                de motivación puede servir un poco cuando una asignatura nos
                cuesta o no nos gusta, pero dificulta el verdadero aprendizaje.{' '}
                <strong>
                  Si esto te pasa con alguna materia, trata de no quedarte solo
                  con lo justo: entender bien los contenidos te ayudará a no
                  tener dificultades más adelante, cuando esos conocimientos
                  sean necesarios para aprender cosas nuevas.
                </strong>
              </p>
            </div>
          </div>

          <br />

          <h3>4.1.3. Motivación por el logro académico</h3>
          <div className='graph-in-text'>
            <div className='chart-col'>
              <div
                className='ability-icon'
                style={{
                  height: 150,
                  display: 'flex',
                  justifyContent: 'center'
                }}
              >
                <img
                  src={medalIcon}
                  alt='icon'
                  style={{ height: '100%', width: 'auto' }}
                />
              </div>
            </div>
            <div style={{ paddingTop: '0.5rem' }}>
              <DonutChart
                height={120}
                barSize={42}
                fontSize={36}
                data={[
                  {
                    id: 'ML_SUB',
                    label: ML_SUB.toFixed(0) + '%',
                    value: ML_SUB,
                    color: '#f7c033'
                  }
                ]}
              />
              <p className='justified'>
                La principal razón para estudiar es poder{' '}
                <strong>
                  tener excelentes calificaciones para poder sobresalir
                </strong>
                , más allá de asegurar un buen aprendizaje. Con esta motivación,
                las personas están dispuestas a hacer grandes esfuerzos para
                alcanzar muy buenas notas y ser mejor que los demás, incluso
                cuando la materia no es interesante.{' '}
                <strong>
                  Esta motivación por el logro puede dificultar el logro de
                  aprendizajes duraderos en el tiempo, pero puede ser útil
                  cuando se va junto con una motivación al aprendizaje profundo.
                </strong>
              </p>
            </div>
          </div>
        </div>
      </BodyContainer>
    </SlidePage>
  );
};

export default MotivationScalesDescriptionCont;
